import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { createRestClient } from '@/contexts/QueryProvider'
import { useGetSearchParam, useSessionStorage } from '@/hooks'
import { ErrorComponent } from '@/ui/ErrorComponent'
import { Loading } from '@/ui/Loading'
import { DataGridComponent } from '../../DataGrid/DataGridComponent'
import { AddWorkspaceForm } from '../../Forms/AddWorkspaceForm'
import { OverlayDrawerComponent } from '../../OverlayDrawerComponent/OverlayDrawerComponent'
import { organisationWorkspacesTableColumns } from './organisationWorkspacesTableColumns'
import { isPlatformAdmin, isSuperUser } from '@/util'

export const OrganisationWorkspacesPanel = () => {
  const queryClient = useQueryClient()
  const orgId = useGetSearchParam<number>('orgId')
  const [isAddOpen, setIsAddOpen] = useState<boolean>(false)

  const { getSubscriptionsApiGetOrganisationWorkspacesSummary } = createRestClient()

  const {
    data: workspacesWithAudit,
    isError,
    isPending,
  } = getSubscriptionsApiGetOrganisationWorkspacesSummary.useQuery({ query: { orgId } })

  const invalidateQueriesOnAdd = () => {
    getSubscriptionsApiGetOrganisationWorkspacesSummary.invalidateQueries(
      { parameters: { query: { orgId } } },
      queryClient
    )
  }

  const [userRole] = useSessionStorage('roles', 1)
  const [isAddWorkspaceAllowed] = useState(() => {
    return isPlatformAdmin(userRole) || isSuperUser(userRole)
  })

  if (isPending) return <Loading />
  if (isError) return <ErrorComponent />

  return (
    <>
      <DataGridComponent
        items={workspacesWithAudit}
        columns={organisationWorkspacesTableColumns}
        heightAdjustment={90}
        onAdd={isAddWorkspaceAllowed ? () => setIsAddOpen(true) : undefined}
      />
      <OverlayDrawerComponent
        open={isAddOpen}
        size="medium"
        setOpen={setIsAddOpen}
        title={'Add workspace'}
        content={
          <AddWorkspaceForm
            orgId={orgId}
            onSubmit={() => {
              invalidateQueriesOnAdd()
              setIsAddOpen(false)
            }}
          />
        }
      />
    </>
  )
}
